<template>
    <prime-product-carousel
        v-if="galleryElements.length > 0"
        :maxDelimiters="6"
        :cycle="false"
        :hide-controls="galleryElements.length <= 1 || hideControls"
        :hide-delimiters="galleryElements.length <= 1"
        v-model="currentSlide"
        class="product-carousel"
        :class="{'elevation-0': noShadow}"
        :height="height"
        :paginator="paginator"
        :loop="loop"
    >
        <div class="badges">
            <v-chip
                v-if="discountRate"
                label
                color="primary"
                text-color="white"
                class="discount-badge"
            >-{{ discountRate }}%</v-chip>
            <img
                v-if="isEngravingProduct"
                class="engraving-badge"
                src="@/assets/engraving_badge_black_33x33.png"
                alt="grill-gravur"
            />
        </div>

        <template v-for="(productImage, index) in galleryElements">
            <v-carousel-item
                v-if="productImage.video_source && productImage.video_source === 'youtube'"
                :aspect-ratio="$vuetify.breakpoint.smAndDown ? '3/4' : '1/1'"
                :key="index"
            >
                <iframe
                    :id="productImage.video_id"
                    :src="getYoutubeLink(productImage.video_id)"
                    allowfullscreen
                ></iframe>
            </v-carousel-item>
            <v-carousel-item
                v-else-if="productImage.video_source && productImage.video_source === 'vimeo'"
                :aspect-ratio="$vuetify.breakpoint.smAndDown ? '3/4' : '1/1'"
                :key="index"
            >
                <iframe
                    :id="productImage.video_id"
                    :src="getVimeoLink(productImage.video_id)"
                    webkitallowfullscreen
                    mozallowfullscreen
                    allowfullscreen
                ></iframe>
            </v-carousel-item>
            <v-carousel-item v-else-if="!productImage.video_source" :key="index">
                <cursor-zoomer
                    v-if="cursorZoomer"
                    :image="productImage.extra"
                    :key="index"
                />

                <v-img
                    v-else
                    lazy
                    ref="image"
                    :src="productImage.big"
                    :contain="contain"
                    @click="$emit('onImageClick')"
                    position="top center"
                    width="100%"
                    class="carousel-image"
                    :class="$vuetify.breakpoint.smAndDown ? 'mobile' : ''"
                    :style="imageStyle"
                />
            </v-carousel-item>
            <v-carousel-item
                v-else
                lazy
                :aspect-ratio="$vuetify.breakpoint.smAndDown ? '3/4' : '1/1'"
                :key="index"
                src="/images/no-available-image.png"
                contain
            />
        </template>
    </prime-product-carousel>
</template>

<script>
    import PrimeProductCarousel from './PrimeProductCarousel';
    import YoutubePlayer from 'youtube-player';
    // import Vimeo from '@vimeo/player';
    import { createNamespacedHelpers } from 'vuex';
    import CursorZoomer from './CursorZoomer';

    const parentModuleName = 'Product';
    const { mapState } = createNamespacedHelpers(parentModuleName);

    export default {
        props: {
            galleryElements: {},
            wheelZoomer: Boolean,
            cursorZoomer: Boolean,
            height: {
                default: '500px',
            },
            value: {
                default: 0,
                type: Number,
            },
            noShadow: Boolean,
            hideControls: Boolean,
            paginator: {},
            contain: {
                type: Boolean,
                default: true,
            },
            loop: Boolean,
            discountRate: Number,
        },
        mounted() {
            this.$nextTick(() => {
                this.indexVideoSlides();
            });
        },
        updated() {
            this.getContentContainer(this);
        },
        data() {
            return {
                youtubePlayers: [],
                vimeoPlayers: [],
                currentlyPlayed: {
                    source: '',
                    videoId: '',
                },
                maxHeight: 0
            };
        },
        components: {
            CursorZoomer,
            PrimeProductCarousel,
        },
        computed: {
            ...mapState({
              product: state => state.product,
              variantId: state => state.currentProductId,
            }),
            ...mapState([
                'variantIds',
            ]),
            imageStyle() {
                const style = {};
                if (this.$vuetify.breakpoint.mdAndUp) {
                    style.maxHeight = `${this.maxHeight}px`;
                }
                return style;
            },
            currentSlide: {
                get() {
                    return this.value;
                },
                set(value) {
                    this.$emit('input', value);
                },
            },
            isEngravingProduct() {
                return this.product.attributes.de.engraving ? true : false;
            }
        },
        methods: {
            getContentContainer(component) {
                if (component.$refs && component.$refs.titleReference) {
                    let hh = 0;
                    try {
                        Object.values(
                                component
                                    .$refs
                                    .titleReference
                                    .$el
                                    .parentElement
                                    .children
                            )
                            .forEach(
                                (child) => {
                                    hh += child.offsetHeight;
                                }
                            );

                    } catch (err) {
                        console.log(err);
                    }
                    if (hh) {
                        this.maxHeight = hh;
                    }
                } else {
                    this.getContentContainer(component.$parent);
                }
            },
            getYoutubeLink(id) {
                return `https://www.youtube.com/embed/${id}?enablejsapi=1`;
            },
            getVimeoLink(id) {
                return `https://player.vimeo.com/video/${id}?title=0&byline=0`;
            },
            onVariantChange(id) {
                if (id) {
                    for (let index of Object.keys(this.galleryElements)) {
                        let productImage = this.galleryElements[index];
                        if (productImage.products.indexOf(id.toString()) !== -1) {
                            this.currentSlide = parseInt(index);
                            break;
                        }
                    }
                }
            },
            indexVideoSlides() {
                let me = this;
                for (let index of Object.keys(this.galleryElements)) {
                    let productImage = this.galleryElements[index];
                    let source = productImage.video_source;

                    if (source == 'vimeo') {
                        // me.vimeoPlayers[productImage.video_id] = new Vimeo(productImage.video_id);
                    } else if (source == 'youtube') {
                        me.youtubePlayers[productImage.video_id] = YoutubePlayer(productImage.video_id);
                    }
                }
            },
            onSlideChange(index) {
                let slide = this.galleryElements[index];
                let player;

                if (slide) {
                    if (this.currentlyPlayed) {
                        if (this.currentlyPlayed.source == 'vimeo') {
                            player = this.vimeoPlayers[this.currentlyPlayed.videoId];
                            player.pause();
                        } else if (this.currentlyPlayed.source == 'youtube') {
                            player = this.youtubePlayers[this.currentlyPlayed.videoId];
                            player.pauseVideo();
                        }
                        if (!slide.video_id) {
                            this.currentlyPlayed = {
                                source: '',
                                videoId: '',
                            };
                        }
                    }

                    if (slide.video_source == 'vimeo' && this.vimeoPlayers[slide.video_id]) {
                        this.vimeoPlayers[slide.video_id].play();
                        this.currentlyPlayed = {
                            source: 'vimeo',
                            videoId: slide.video_id,
                        };
                    } else if (slide.video_source == 'youtube' && this.youtubePlayers[slide.video_id]) {
                        player = this.youtubePlayers[slide.video_id];
                        if (typeof player.setPlaybackQuality == 'function' && typeof player.playVideo == 'function') {
                            player.setPlaybackQuality(slide.video_quality);
                            player.playVideo();
                            this.currentlyPlayed = {
                                source: 'youtube',
                                videoId: slide.video_id,
                            };
                        }
                    }
                }
            },
            zoomIn() {
                let currentImage = this.galleryElements[this.currentSlide];
                if (currentImage && this.$refs['zoomer-' + currentImage.original_image_path]) {
                    this.$refs['zoomer-' + currentImage.original_image_path][0].zoomIn();
                }
            },
            zoomOut() {
                let currentImage = this.galleryElements[this.currentSlide];
                if (currentImage && this.$refs['zoomer-' + currentImage.original_image_path]) {
                    this.$refs['zoomer-' + currentImage.original_image_path][0].zoomOut();
                }
            },
        },
        watch: {
            variantId: {
                handler: 'onVariantChange',
                immediate: true,
            },
            currentSlide: {
                handler(value) {
                    this.$emit('slideChange', value);
                    this.onSlideChange(value);
                },
                immediate: true,
            },
            variantIds(value) {
                for (let index of Object.keys(this.galleryElements)) {
                    let productImage = this.galleryElements[index];
                    for (let productId of productImage.products) {
                        if (value.indexOf(parseInt(productId)) !== -1) {
                            this.onVariantChange(productId);
                            break;
                        }
                    }
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    .badges {
        position: absolute;
        display: grid;
        top: 10px;
        right: 10px;
        z-index: 1;
    }
    .discount-badge {
        margin-right: 0;
        right: unset;
        top: unset;
        position: unset;
    }
    .engraving-badge {
        margin-left: auto;
        position: unset;
    }
    .carousel-image {
        &.mobile {
            max-height: 80vh;
        }
    }
</style>
